<button class="btn btn-primary btn-stretch" (click)="onButtonPressed()"
type="button"><i class="bx {{component.style.icon}}" *ngIf="component.style.icon"></i> {{component.data.text}}</button>